import { render, staticRenderFns } from "./Prospect.vue?vue&type=template&id=f9a1c3a0&scoped=true"
import script from "./Prospect.vue?vue&type=script&lang=js"
export * from "./Prospect.vue?vue&type=script&lang=js"
import style0 from "./Prospect.vue?vue&type=style&index=0&id=f9a1c3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a1c3a0",
  null
  
)

export default component.exports